var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.78 16.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f8853eb2-e731-442c-9670-e56570e5e9e3",
    x1: 3,
    y1: 11.49,
    x2: 85.78,
    y2: 11.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ba8f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "both") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f44bd319-fcda-44c3-b0b8-8a6ec577c8e8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea5e7aaa-6aa9-4c37-bade-332b77e6f82c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.19,
    width: 82.78,
    height: 10.59,
    fill: "url(#f8853eb2-e731-442c-9670-e56570e5e9e3)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 82.78,
    height: 10.59,
    fill: "#22364c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoth);
export default __webpack_public_path__ + "static/media/both.c4e52e272e4b9e5b6690651e0ea24d3b.svg";
export { ForwardRef as ReactComponent };